<div class="layout-header surface-ground sticky top-0 pb-0 z-5"> 
    <div class="layout-header-wrapper">
        
        <!-- start: TITLE AND LOGOS -->
        <div class="grid hidden lg:flex">
            <div class="col-6 pt-0 pb-0">
                <div class="flex overflow-hidden my-0">
                    <div class="flex-shrink-0 flex align-items-center justify-content-center cursor-pointer" *ngIf="stickyHeader.showBackButton; else noBackButton" (click)="goBack()">
                        <i class="pi pi-angle-left text-2xl pr-2"></i>
                        <h5 class="text-3xl mt-0 mb-0 font-bold" i18n>{{ stickyHeader.title }}</h5>
                    </div>
                    <ng-template #noBackButton>
                        <div class="flex-shrink-0 flex align-items-center justify-content-center">
                            <h5 class="text-3xl mt-0 mb-0 font-bold" i18n>{{ stickyHeader.title }}</h5>
                        </div>
                    </ng-template>
                </div>
            </div>

            <!-- start: BUTTONS -->
            <div class="col-6 pt-0 pb-0 text-right hidden lg:block" *ngIf="stickyHeader.buttons != undefined && stickyHeader.buttons.length > 0">
                @for (button of stickyHeader.buttons; track button; let first = $first) {
                    <p-button [label]="button.label" icon="pi pi-plus" [outlined]="button.outlined" [icon]="button.icon"
                        styleClass="p-button" [ngClass]="!first ? ' ml-2' : ''" [routerLink]="button.routerLink" i18n-label
                    ></p-button>
                }
            </div>
            <!-- end: BUTTONS -->
        </div>
        
        <div class="lg:hidden pt-0 pb-0">
            <div class="flex overflow-hidden my-0">
                <div class="flex-shrink-0 flex align-items-center justify-content-center cursor-pointer" *ngIf="stickyHeader.showBackButton; else noBackButton" (click)="goBack()">
                    <i class="pi pi-angle-left text-2xl pr-2"></i>
                    <h5 class="text-3xl mt-0 mb-0 font-bold" i18n>{{ stickyHeader.title }}</h5>
                </div>
                <ng-template #noBackButton>
                    <div class="flex-shrink-0 flex align-items-center justify-content-center">
                        <h5 class="text-3xl mt-0 mb-0 font-bold" i18n>{{ stickyHeader.title }}</h5>
                    </div>
                </ng-template>
                <div class="flex-grow-1 flex-shrink-1 flex align-items-center justify-content-end hidden md:block lg:hidden">
                    <img class="mt-0 hidden md:block lg:hidden" style="width: 6rem; height: 3rem;" src="assets/media/logos/aceleradora_unoentrecienmil.png" alt="Uno entre cienmil">
                </div>
            </div>
        </div>
        <!-- end: TITLE AND LOGOS -->
        

        <!-- start: PATIENT HEADER COMPONENT -->
        <app-patient-header *ngIf="stickyHeader.patientHeader != undefined" [patientHeader]="stickyHeader.patientHeader"></app-patient-header>
        <!-- end: PATIENT HEADER COMPONENT -->

        <!-- start: SESSION HEADER COMPONENT -->
        <app-session-header *ngIf="stickyHeader.sessionHeader != undefined" [sessionHeader]="stickyHeader.sessionHeader"></app-session-header>
        <!-- end: SESSION HEADER COMPONENT -->

        <!-- start: CLINICAL ASSESSMENT HEADER COMPONENT -->
        <app-assessment-header *ngIf="stickyHeader.assessmentHeader != undefined" [assessmentHeader]="stickyHeader.assessmentHeader"></app-assessment-header>
        <!-- end: CLINICAL ASSESSMENT HEADER COMPONENT -->

    </div>
</div> 